/* =========================================================================
   TEABO v5 — Bandeau pays / devise
   -------------------------------------------------------------------------
   Détection : GET /browsing_context_suggestions.json (endpoint natif Shopify,
   documenté sous « localization discovery »). Vérifié en direct sur cette
   boutique le 20.08.2026 : 200, application/json.

   ARBITRAGE QUENTIN DU 20.08 : on demande à TOUT LE MONDE, y compris au
   visiteur déjà placé dans le bon marché — « vraiment pour être sûr d'avoir
   la bonne version du site pour le bon utilisateur ».
   Conséquence technique : on N'ENVOIE PLUS `country[exclude]`. Sans lui,
   l'API suggère toujours quelque chose, y compris le marché courant, et
   c'est nous qui décidons du message. Trois cas :
     • détecté ≠ actif, et servi   → on propose la BASCULE
     • détecté = actif             → on CONFIRME, sans rien changer
     • détecté non servi           → on ouvre la LISTE des pays
   Un échec de l'appel reste silencieux : mieux vaut aucun bandeau qu'un
   bandeau qui s'affiche à tout le monde pendant un incident Shopify.

   ⚠ NE PAS utiliser `window.Shopify.language` : cette propriété N'EXISTE PAS
   (le bout de code de la doc Shopify est fautif). C'est `Shopify.locale`.
   Ici on ne demande pas de suggestion de langue du tout : la boutique n'a
   qu'une locale, une suggestion serait toujours vide ou fausse.

   ⚠ Aucun nom de pays, aucune devise, aucune mention de douane dans ce
   fichier : un asset est mis en cache un an. Tout vient du <script
   type="application/json"> rendu en Liquid par la section.
   ========================================================================= */
(function () {
  'use strict';

  var bandeau = document.querySelector('[data-v5loc]');
  if (!bandeau) return;
  var visible = false;
  var isoSuggere = null;
  var dernierDeclencheur = null;

  /* ⚠ requestAnimationFrame est GELÉ dans un onglet en arrière-plan
     (visibilityState "hidden") : vérifié le 20.08, le rAF ne se déclenche
     jamais. Toute la révélation en dépendait — le bandeau restait alors à
     `hidden=false` mais opacité 0 : invisible ET focusable au clavier, le
     pire des deux. Filet : ce qui n'a pas tourné en rAF tourne après 60 ms. */
  function auProchainRendu(cb) {
    var fait = false;
    var une = function () { if (fait) { return; } fait = true; cb(); };
    requestAnimationFrame(une);
    setTimeout(une, 60);
  }

  var CLE = 'teabo_loc_v1';
  var REFUS_JOURS = 30;
  var REFUS_MAX = 2;

  var paysActif = (window.Shopify && window.Shopify.country) || bandeau.dataset.paysActif || '';
  var deviseActive = bandeau.dataset.deviseActif || '';
  var racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var exclus = (bandeau.dataset.exclus || '').toUpperCase().split(',').map(function (s) { return s.trim(); });
  var delai = parseInt(bandeau.dataset.delai, 10);
  if (isNaN(delai)) delai = 4000;

  var table = {};
  try {
    table = JSON.parse(bandeau.querySelector('[data-v5loc-pays]').textContent);
  } catch (e) { return; }              /* sans la table, pas de phrase : on s'abstient */

  /* --- Mémoire du choix -------------------------------------------------
     Une SEULE clé, pas une par couple pays/langue : la règle « choix manuel
     = plus jamais de suggestion » ne s'exprime pas avec une clé par paire.
     On ne stocke que le code pays, un état et un horodatage — jamais d'IP ni
     d'identifiant, et cette valeur n'est jamais relue par autre chose que ce
     fichier. C'est ce qui la fait tenir dans l'exemption « préférence
     d'interface » (délibération CNIL 2020-092), donc sans bandeau de
     consentement. Ne pas la réutiliser pour de la mesure d'audience. */
  function lire() {
    try { return JSON.parse(localStorage.getItem(CLE)) || null; } catch (e) { return null; }
  }
  function ecrire(o) {
    try { localStorage.setItem(CLE, JSON.stringify(o)); } catch (e) { /* mode privé */ }
  }

  /* Un choix explicite du visiteur bat toujours une détection : dès qu'il
     touche un formulaire de localisation, on ne le sollicite plus jamais. */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.getAttribute('action') !== racine + 'localization') return;
    if (bandeau.contains(f) && bandeau.dataset.mode !== 'liste') return;
    var choix = e.submitter && e.submitter.name === 'country_code' ? e.submitter.value : paysActif;
    memo = { v: 1, pays: choix, etat: 'manuel', n: 0, ts: Date.now() };
    ecrire(memo);
  }, true);

  /* ⚠ Ce gestionnaire doit être posé AVANT toute sortie anticipée : c'est le
     seul point d'entrée manuel vers le choix du pays. Il était plus bas dans
     le fichier, donc jamais enregistré dès que la mémoire valait « manuel » —
     le lien du pied de page ne faisait alors plus rien. */
  document.addEventListener('click', function (e) {
    var d = e.target.closest && e.target.closest('[data-v5loc-ouvrir]');
    if (!d) return;
    e.preventDefault();
    dernierDeclencheur = d;

    /* ⚠ Ouverture MANUELLE : elle ne passe pas par afficher(), donc rien ne
       remplaçait {pays} et {devise} — le panneau montrait les jetons bruts.
       Et une suggestion n'a de toute façon aucun sens ici : c'est le visiteur
       qui demande la liste. On pose un titre neutre et on efface tout ce qui
       relève de la proposition. */
    var q = function (sel) { return bandeau.querySelector(sel); };
    q('[data-v5loc-titre]').textContent = bandeau.dataset.tListe || 'Choisissez votre pays';
    q('[data-v5loc-texte]').textContent = bandeau.dataset.xListe || '';
    q('[data-v5loc-accepter]').hidden = true;
    q('[data-v5loc-refuser]').hidden = true;
    q('[data-v5loc-douane]').textContent = '';
    q('[data-v5loc-voir-pays]').hidden = true;
    bandeau.dataset.mode = 'liste';

    bandeau.querySelector('[data-v5loc-panneau]').hidden = false;
    bandeau.hidden = false;
    visible = true;
    auProchainRendu(function () {
      document.documentElement.style.setProperty('--v5loc-h', bandeau.offsetHeight + 'px');
      bandeau.classList.add('est-visible');
      var b = bandeau.querySelector('.v5loc__pays-btn');
      if (b) b.focus();          /* ici le focus se déplace : c'est une action volontaire */
    });
  });

  var memo = lire();

  /* --- Détection --------------------------------------------------------- */
  function detecter() {
    var p = new URLSearchParams();
    p.set('country[enabled]', 'true');
    p.set('language[enabled]', 'false');
    /* pas de country[exclude] : on veut la détection même quand elle tombe
       sur le marché courant (voir l'en-tête) */

    var ctrl = new AbortController();
    var minuteur = setTimeout(function () { ctrl.abort(); }, 1500);

    return fetch(racine + 'browsing_context_suggestions.json?' + p.toString(), {
      headers: { Accept: 'application/json' },
      signal: ctrl.signal
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        clearTimeout(minuteur);
        if (!d || !d.suggestions || !d.suggestions.length) return null;
        /* La forme de `parts` n'est pas contractuelle : objet observé en
           août 2026, tableau décrit ailleurs. On lit les deux. */
        var brut = d.suggestions[0].parts;
        var pays = Array.isArray(brut)
          ? brut.filter(function (x) { return x && x.type === 'country'; })[0]
          : brut && brut.country;
        return pays && pays.handle ? pays.handle.toUpperCase() : null;
      })
      .catch(function () { clearTimeout(minuteur); return null; });  /* silence : le
        sélecteur de la liste complète reste le filet */
  }

  /* --- Recevabilité ------------------------------------------------------ */
  /* Le mode décide du message ET du bouton. */
  function modeDe(iso) {
    if (!table[iso]) return 'inconnu';                 /* pays détecté hors des marchés servis */
    if (iso === paysActif) return 'confirme';
    if (exclus.indexOf(iso) !== -1) return 'confirme'; /* ex. GB : on ne pousse pas, on confirme l'actuel */
    return 'bascule';
  }

  function recevable(iso) {
    if (!iso) return false;
    if (!memo) return true;
    if (memo.pays !== iso) return true;                /* le voyageur qui change de pays revoit la question */
    if (memo.etat === 'accepte' || memo.etat === 'confirme') return false;
    if (memo.etat === 'refuse') {
      if ((memo.n || 0) >= REFUS_MAX) return false;
      return Date.now() - (memo.ts || 0) > REFUS_JOURS * 864e5;
    }
    return true;
  }

  /* --- Affichage --------------------------------------------------------- */

  function afficher(iso) {
    if (visible) return;

    /* On ne propose pas une bascule de devise pendant que le panier est
       ouvert : le changement de marché RECHARGE la page et recalcule le
       panier. Le panier v5 est un tiroir, pas une page. */
    if (document.body.classList.contains('cart-drawer-open')) return;
    if (document.getElementById('shopify-pc__banner')) return;

    var mode = modeDe(iso);
    var info = table[iso] || table[paysActif] || { n: '', a: '', d: deviseActive, x: '' };
    var q = function (s) { return bandeau.querySelector(s); };
    var d = bandeau.dataset;

    /* Les phrases viennent des réglages de section, jamais d'ici : elles
       doivent rester modifiables dans l'éditeur de thème. */
    var remplir = function (modele, pays, devise) {
      return (modele || '')
        .replace('{pays}', pays)
        .replace('{devise}', monnaie(devise));
    };

    var accepter = q('[data-v5loc-accepter]');
    var refuser = q('[data-v5loc-refuser]');
    var panneau = q('[data-v5loc-panneau]');

    if (mode === 'bascule') {
      q('[data-v5loc-titre]').textContent = remplir(d.tBascule, info.a + info.n, info.d);
      q('[data-v5loc-texte]').textContent = remplir(d.xBascule, info.a + info.n, info.d);
      accepter.type = 'submit';
      accepter.value = iso;
      accepter.textContent = 'Passer en ' + monnaie(info.d) + ' (' + info.d + ')';
      refuser.hidden = false;
      refuser.textContent = 'Rester en ' + monnaie(deviseActive) + ' (' + deviseActive + ')';
      q('[data-v5loc-douane]').textContent = info.x || '';

    } else if (mode === 'confirme') {
      /* Le visiteur est DÉJÀ au bon endroit : on ne lui propose pas de
         changer quelque chose de juste, on le lui confirme. Le bouton ne
         poste rien — aucun rechargement pour un choix qui ne change rien. */
      var ici = table[paysActif] || info;
      q('[data-v5loc-titre]').textContent = remplir(d.tConfirme, ici.a + ici.n, deviseActive);
      q('[data-v5loc-texte]').textContent = remplir(d.xConfirme, ici.a + ici.n, deviseActive);
      accepter.type = 'button';
      accepter.textContent = d.bConfirme || 'C\'est bien mon pays';
      refuser.hidden = true;                       /* « rester » n'a pas de sens ici */
      q('[data-v5loc-douane]').textContent = ici.x || '';

    } else {
      /* Pays détecté hors des marchés servis : on n'a rien à proposer, on
         ouvre directement la liste. */
      q('[data-v5loc-titre]').textContent = 'Où souhaitez-vous être livré ?';
      q('[data-v5loc-texte]').textContent =
        'Nous livrons en Suisse, en Europe et au Royaume-Uni. Choisissez votre pays pour voir les bons prix.';
      accepter.hidden = true;
      refuser.hidden = true;
      q('[data-v5loc-douane]').textContent = '';
      panneau.hidden = false;
    }

    bandeau.dataset.mode = mode;

    bandeau.hidden = false;
    visible = true;

    /* SC 2.4.11 — le bandeau ne doit pas masquer un élément qui reçoit le
       focus. On publie sa hauteur, la feuille s'en sert en scroll-padding. */
    auProchainRendu(function () {
      document.documentElement.style.setProperty('--v5loc-h', bandeau.offsetHeight + 'px');
      bandeau.classList.add('est-visible');
    });

    /* On n'annonce pas au chargement et on ne vole PAS le focus : le bandeau
       est une région, pas une boîte de dialogue. */
    q('[data-v5loc-annonce]').textContent =
      'Suggestion de pays disponible en bas de page.';
  }

  function monnaie(code) {
    return code === 'EUR' ? 'euros'
         : code === 'CHF' ? 'francs suisses'
         : code === 'GBP' ? 'livres sterling'
         : code;
  }

  function cacher(etat, iso) {
    bandeau.classList.remove('est-visible');
    document.documentElement.style.setProperty('--v5loc-h', '0px');
    visible = false;
    var fin = function () { if (!visible) bandeau.hidden = true; };
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) fin();
    else setTimeout(fin, 240);
    if (dernierDeclencheur && document.contains(dernierDeclencheur)) dernierDeclencheur.focus();
    dernierDeclencheur = null;
    if (etat) {
      var n = memo && memo.pays === iso && memo.etat === 'refuse' ? (memo.n || 0) + 1 : 1;
      memo = { v: 1, pays: iso, etat: etat, n: n, ts: Date.now() };
      ecrire(memo);
    }
  }

  /* --- Câblage ----------------------------------------------------------- */
  // Les commandes manuelles fonctionnent même sans suggestion ou après un choix mémorisé.
    bandeau.querySelector('[data-v5loc-accepter]').addEventListener('click', function (e) {
      if (bandeau.dataset.mode === 'confirme') {
        /* rien à changer : on note et on referme, sans rechargement */
        e.preventDefault();
        cacher('confirme', isoSuggere || paysActif);
        return;
      }
      ecrire({ v: 1, pays: isoSuggere || paysActif, etat: 'accepte', n: 0, ts: Date.now() });
      /* on laisse le submit natif partir : POST /localization puis rechargement */
    });
    bandeau.querySelector('[data-v5loc-refuser]').addEventListener('click', function () {
      cacher('refuse', isoSuggere || paysActif);
    });
    bandeau.querySelector('[data-v5loc-fermer]').addEventListener('click', function () {
      if (bandeau.dataset.mode === 'liste') cacher();
      else cacher('refuse', isoSuggere || paysActif);
    });
    bandeau.querySelector('[data-v5loc-voir-pays]').addEventListener('click', function (e) {
      var panneau = bandeau.querySelector('[data-v5loc-panneau]');
      var ouvert = !panneau.hidden;
      panneau.hidden = ouvert;
      e.target.setAttribute('aria-expanded', String(!ouvert));
      auProchainRendu(function () {
        document.documentElement.style.setProperty('--v5loc-h', bandeau.offsetHeight + 'px');
      });
    });

    /* Échap ne ferme QUE si le focus est dans le bandeau : la région n'est pas
       modale, on ne capture pas la touche pour le reste de la page. */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !visible) return;
      if (!bandeau.contains(document.activeElement)) return;
      if (bandeau.dataset.mode === 'liste') cacher();
      else cacher('refuse', isoSuggere || paysActif);
    });

  if (memo && memo.etat === 'manuel') return;
  detecter().then(function (iso) {
    isoSuggere = iso;
    if (!recevable(iso)) return;

    /* Déclenchement : le délai OU 20 % de défilement, le premier des deux.
       Jamais au chargement — un panneau pays qui s'ouvre à l'arrivée est pris
       pour une publicité et fermé sans être lu. */
    var parti = false;
    var lancer = function () {
      if (parti) return;
      parti = true;
      window.removeEventListener('scroll', auScroll);
      afficher(iso);
    };
    var auScroll = function () {
      if (window.scrollY > window.innerHeight * 0.2) lancer();
    };
    setTimeout(lancer, delai);
    window.addEventListener('scroll', auScroll, { passive: true });
  });
})();
